import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500">
        Guess the Noadz in 6 tries. After each guess, the color of the tiles
        will change to show how close your guess was to the word.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell value="P" status="correct" />
        <Cell value="L" />
        <Cell value="A" />
        <Cell value="N" />
        <Cell value="E" />
      </div>
      <p className="text-sm text-gray-500">
        The letter P is in the word and in the correct spot.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell value="F" />
        <Cell value="E" />
        <Cell value="N" status="present" />
        <Cell value="C" />
        <Cell value="E" />
      </div>
      <p className="text-sm text-gray-500">
        The letter N is in the word but in the wrong spot.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell value="S" />
        <Cell value="W" />
        <Cell value="O" />
        <Cell value="R" status="absent" />
        <Cell value="D" />
      </div>
      <p className="text-sm text-gray-500">
        The letter R is not in the word in any spot.
      </p>
    </BaseModal>
  )
}
